import { createContext, useState, useMemo } from "react";
import PropTypes from "prop-types";

const context = {
    settings: {},
    accounts: null,
    updateSettings: () => {},
    updateAccounts: () => {},
    clearSettings: () => {}
}

export const UserAccountContext = createContext(context);

const UserAccountContextProvider = ({ children }) => {
    const [settings, setSettings] = useState({});
    const [accounts, setAccounts] = useState(null);

    const updateSettings = (newSettings) => {
        setSettings(prevSettings => ({
            ...prevSettings,
            ...newSettings
        }));
    }

    const clearSettings = () => {
        setSettings({});
    }

    /**
     * Updates user accounts in context
     * @param {object[]|null} newAccounts
     */
    const updateAccounts = (newAccounts) => {
        setAccounts(newAccounts);
    }

    const providerValue = useMemo(() => (
        { settings, updateSettings, clearSettings, accounts, updateAccounts }
    ), [settings, updateSettings, clearSettings, accounts, updateAccounts]);

    return (
        <UserAccountContext.Provider value={providerValue}>
            {children}
        </UserAccountContext.Provider>
    )
}

UserAccountContextProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export default UserAccountContextProvider;
